<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-texture`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46.276 8.807L43.448 5.98l-9.9 9.9-9.899-9.9-9.9 9.9-9.9-9.9-2.828 2.828L13.75 21.535l9.9-9.9 9.9 9.9L46.275 8.807zm0 21l-2.828-2.828-9.9 9.9-9.899-9.9-9.9 9.9-9.9-9.9-2.828 2.828L13.75 42.535l9.9-9.9 9.9 9.9 12.727-12.728z"/></svg>
</template>
<script>

export default {
  name: 'IconTexture',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
